import cadStudio1 from "../../images/sections/gallery/cadStudio/dent_0.jpg";
import cadStudio2 from "../../images/sections/gallery/cadStudio/dent_1.png";
import cadStudio3 from "../../images/sections/gallery/cadStudio/dent_2.jpg";
import cadStudio6 from "../../images/sections/gallery/cadStudio/dent_5.png";
import cadStudio7 from "../../images/sections/gallery/cadStudio/dent_6.png";
import cadStudio8 from "../../images/sections/gallery/cadStudio/dent_7.png";
import cadStudio9 from "../../images/sections/gallery/cadStudio/dent_8.png";
import cadStudio10 from "../../images/sections/gallery/cadStudio/dent_9.png";

export const cadStudio = [ cadStudio1, cadStudio2, cadStudio3, cadStudio6, cadStudio7, cadStudio8, cadStudio9, cadStudio10];